import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { style: {"height":"calc(100vh - 48px)","width":"calc(100vh - 48px)"} }
const _hoisted_2 = {
  key: 1,
  class: "p-10 flex items-center justify-center"
}

import { onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { PageLoading } from '@/lib/components/Loading';
import { PdfViewer } from '@/lib/components/Viewer';
import { BaseModal } from '@/lib/components/Modals';
import { FileService } from '@/services/api';
import { useNotificationStore } from '@/stores/notification.store';
import axios from 'axios';


export default /*#__PURE__*/_defineComponent({
  __name: 'PatientSupportingDocumentModal',
  props: {
  documentId: {
    type: String,
    required: true
  }
},
  emits: ["close"],
  setup(__props, { emit: __emit }) {

const { t } = useI18n();
const props = __props;
const emit = __emit;

const fileService = new FileService();
const pdf = ref('');
const notificationStore = useNotificationStore();

onMounted(() => {
  getPdf(props.documentId);
});
const getPdf = async (id: string) => {
  try {
    const response = await fileService.fetchBase64Pdf(id);

    pdf.value = `data:application/pdf;base64,${response}`;
  } catch (e) {
    if (!axios.isAxiosError(e)) {
      throw e;
    }
    await notificationStore.addErrorNotification({
      title: t('custom.uhb.consult.error-retrieving-document'),
      label: e.response.data
    });
    emit('close', e);
  }
};
const closeModal = () => {
  emit('close');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseModal), {
    class: "inline-block bg-white",
    "vertical-align": "center",
    "close-on-background-click": true,
    onClose: closeModal
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (pdf.value?.length)
          ? (_openBlock(), _createBlock(_unref(PdfViewer), {
              key: 0,
              pdf: pdf.value,
              class: "w-full h-full"
            }, null, 8, ["pdf"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_unref(PageLoading))
            ]))
      ])
    ]),
    _: 1
  }))
}
}

})